module.exports = __webpack_public_path__ + "img/img_article6_radio_v3@3x_hover.3e9a256a.png";